import React from 'react';
import { FaLinkedin, FaGithub, FaEnvelope } from 'react-icons/fa';

// @ts-ignore
const FaLinkedinIcon = FaLinkedin as any;
// @ts-ignore
const FaGithubIcon = FaGithub as any;
// @ts-ignore
const FaEnvelopeIcon = FaEnvelope as any;

interface CirclePicProp {
    src: string;
    alt: string;
}

const CirclePic: React.FC<CirclePicProp> = ({ src, alt }) => {
    return (
        <div className="flex flex-col items-center space-y-4 bg-black/40 border border-terminal-subtle p-6 rounded-lg shadow-[0_0_15px_rgba(0,255,65,0.05)] backdrop-blur-sm group hover:border-terminal-text transition-all duration-500">
            <div className="relative">
                <div className="absolute -inset-1 bg-terminal-text rounded-full opacity-0 group-hover:opacity-20 blur transition-opacity duration-500"></div>
                <img
                    src={src}
                    alt={alt}
                    className="relative rounded-full border-2 border-terminal-subtle group-hover:border-terminal-text transition-colors duration-500 w-48 h-48 object-cover"
                />
            </div>
            <div className="flex justify-center space-x-3">
                <a href="https://linkedin.com/in/actiii03/" className="text-terminal-accent hover:text-terminal-text">
                    <FaLinkedinIcon size="24" />
                </a>
                <a href="https://github.com/ActIII03" className="text-terminal-accent hover:text-terminal-text">
                    <FaGithubIcon size="24" />
                </a>
                <a href="mailto:a.touche03@google.com" className="text-terminal-accent hover:text-terminal-text">
                    <FaEnvelopeIcon size="24" />
                </a>
            </div>
        </div>
    );
}

export default CirclePic;

